import React, { useEffect, useMemo, useState } from 'react'
import LineChart from './lineChart';
import { getTransactionsChartData, getYearLookup } from './api';
import numberFormatter from 'src/utils/numberFormatter';
import { numberFormat } from 'highcharts';
import { Alert } from 'react-bootstrap';
import Loader from 'src/components/loader.component';
import apiCalls from 'src/api/apiCalls';
import { Select } from 'antd';
import SelectInput from 'src/components/shared/selectInput';

const { Option } = Select;
const chartProps = {
    type: "column",
    backgroundColor: "Transparent",
    height: 400,
    marginBottom: 100,
    marginTop: 30,
    style: {
        fontFamily: "Segoe UI",
    }
};
const otherOptions = {
    title: {
        text: '',
    },
    tooltip: {
        formatter: function () {
            const { number: value, suffix = '' } = numberFormatter(this.y)
            return `${this.series.name}: <b>$${numberFormat(value, 2, '.', ',')}${suffix}</b>`;
        }
    },
    xAxis: {
        type: 'category',
        labels: {
            rotation: -45,
            formatter: function () {
                const text = this.value,
                    formatted = text.length > 15 ? text.substring(0, 12) + '...' : text;

                return '<div title="' + text + '">' + formatted + '</div>';
            },
            useHTML: true,
            style: {
                color: '#FFFFFF'
            }
        }
    },
    yAxis: {
        title: {
            text: `<span class="text-light-valueColor">USD</span>`,
            useHTML: true
        },
        labels: {
            style: {
                color: '#FFFFFF'
            },
            formatter: function () {
                const { number: value, suffix = '' } = numberFormatter(this.value)
                return `${numberFormat(value, 2, '.', ',')}${suffix}`;
            }
        }
    },
    lang: {
        thousandsSep: ',' // Set comma as the thousands separator
    },
    credits: {
        enabled: false
    },
}
const TransactionsChart = ({ module,seriesKey }) => {
    const [years, setYears] = useState(null)
    const [filters, setFilters] = useState(null)
    const [gettingYears, setGettingYears] = useState(false);
    const [error, setError] = useState('')
    useEffect(() => {
        const currDate = new Date()
        setGettingYears(true)
        getYears()
        setFilters({ year: currDate.getFullYear() })
    }, [])
    const getYears = async () => {
        try {
            const response = await getYearLookup();
            if (response.ok) {
                setYears(response.data['Years'])
            } else {
                setError(apiCalls.isErrorDispaly(response))
            }
        } catch (errorMsg) {
            setError(apiCalls.isErrorDispaly(errorMsg))
        } finally {
            setGettingYears(false)
        }

    }
    const handleFilterChange = (value, filter) => {
        setFilters((prev) => ({ ...prev, [filter]: value }))
    }
    const fetchParams = useMemo(() => {
        return [module, filters]
    }, [module, filters])
    return (
        <div className="App">
            <div className='flex justify-between items-center'>
                <h3 className='text-light-valueColor font-semibold text-lg dark:text-dark-valueColor '>{module==='Cards' ? 'Card Transactions' : module ==='cryptoTransactions' ? 'Crypto Transactions' : 'Transactions'}</h3>
                <SelectInput options={years} customClass='min-w-[150px]'  fieldName="year" loading={gettingYears}defaultValue={filters?.year} value={filters?.year} onChange={(value) => handleFilterChange(value, 'year')}allowClear = {false}/>
            </div>
            {error && <Alert variant="danger">
                <p style={{ color: 'red', margin: 10 }}><span className="icon error-alert me-2"></span>{error}</p>
            </Alert>}
            {!filters && <Loader />}
            {filters && <LineChart
                shouldFetch={true}
                chartProperties={chartProps}
                fetchMethod={getTransactionsChartData}
                seriesKey={seriesKey}
                otherOptions={otherOptions}
                axiskey={'yAxis'}
                hasFetchParams={true}
                fetchParams={fetchParams}
                gettingFilters={gettingYears}
            />}
        </div>
    );
}

export default React.memo(TransactionsChart)